/**
 * ADRES DESENİ — `email-mask-structure.ts`in EŞLEŞTİRME YARISI, AYRI DOSYA.
 *
 * NEDEN AYRI (sekizinci dalga, 16.09.2026): `email-mask-structure.ts` kaynak
 * tavanını (500 satır) aştı; bu turda atıl maddeye ÜÇÜNCÜ kip (`secici`) ve
 * bileşim ayağının tabanı (`sar`, `kurban`) girdi. Ayrım kavramsaldır, mekanik
 * değil: BURASI "adres neye benzer" sorusunu cevaplar (parçalar, ara, TLD
 * çapası), `email-mask-structure.ts` "parçaların arasında ne bulunabilir"
 * sorusunu (atıl madde).
 *
 * Kamuya açık yüzey `email-mask-structure.ts`ten yeniden dışa verilir;
 * çağıranlar ve spec eski yolu sürmeye devam eder.
 */
/**
 * PARÇALAR ARASINDAKİ ARANIN ÜST SINIRI (karakter) — ARTIK SİHİRLİ SAYI DEĞİL.
 *
 * Atıl madde söküldükten VE `boslugaIndirge` koştuktan sonra `@`nin iki yanında
 * en çok BİR boşluk kalabilir; değer bu olgudan TÜRER, ölçüden ya da tahminden
 * değil. Eski değeri `8`di ve gerekçesi kodda yazılı değildi — dokuz boşlukla
 * atlatılıyordu (yukarıdaki başlık).
 *
 * Sınır SIFIR OLAMAZ — sıfır, "bitişiklik şartı"nın kendisidir ve
 * `ali <span></span> @ ornek.com` gibi söküm artığı boşlukları kaçırırdı.
 * Kapı üç ayağı da ölçer: 0 verildiğinde sızıntı GERİ GELİR (14a), bugünkü
 * değerde gelmez, ve KEYFİ uzunluktaki boşluk kümesi de sızmaz (14a2).
 */
export const ARA_ESIGI = 1;
export const YAPISAL_VARSAYILAN = { araEsigi: ARA_ESIGI, tldZorunlu: true };
/**
 * "Sözcük" karakteri — SADECE ASCII DEĞİL.
 *
 * `ali@örnek.com` ve `çağrı@ornek.com` bir turda HİÇ maskelenmiyordu, çünkü
 * hem yerel ad hem alan adı sınıfı `[A-Za-z0-9]` ile başlıyordu. Ürünün ana
 * pazarı Türkiye, sözleşme dili `tr` ve SMTPUTF8 yaygın. `\p{M}` ayrıştırılmış
 * diziler (`i̇`) içindir, `\p{Extended_Pictographic}` emoji alan adları için
 * (`ali@😀.ws` — `.ws`/`.to` bunları gerçekten satar).
 */
const SOZCUK = String.raw `\p{L}\p{N}\p{M}\p{Extended_Pictographic}`;
/**
 * YEREL AD. Tırnaklı biçim RFC 5321'e göre boşluk taşıyabilir
 * (`"ali veli"@ornek.com`) ve TAVANI YOKTUR: tavanlı her desen tavanın
 * üstünde fail-open olur (bu turdan önce `{1,255}` böyle sızdırıyordu).
 * `[^"\r\n]*` tek bir karakter sınıfıdır ve ardındaki `"` ile çapalıdır —
 * iç içe yineleme yoktur, maliyet doğrusaldır.
 */
const YEREL = String.raw `(?:"[^"\r\n]*"|[${SOZCUK}!#$%&'*+/=?^_\u0060{|}~.-]+)`;
/**
 * BİTİŞİK ALAN. Köşeli ayraçlı biçim alan adı yerine IP taşır
 * (`ali@[203.0.113.9]`). Alan adında NOKTA ZORUNLU DEĞİL:
 * `postmaster@localhost` da adrestir. Sondaki nokta (`… <a@b.co>.`) adresin
 * parçası sayılmaz, bu yüzden sınıf sözcük karakteriyle biter.
 */
const ALAN_BITISIK = String.raw `(?:\[[^\]\r\n]{1,45}\]|[${SOZCUK}](?:[${SOZCUK}._-]*[${SOZCUK}])?)`;
/*
 * TLD TAŞIYAN ALAN — ARALI YAZIMIN ÇAPASI.
 *
 * Etiket TEK yinelemeyle yazılır (`[S][S-]*`): `[S](?:[S-]*[S])?` biçimi aynı
 * etiketi birden çok yolla eşleştirebilir ve `(?:etiket\.)+` altında geri
 * izleme çarpımsal büyür. Bugünkü biçimde her etiket `\.` ile çapalıdır,
 * ayrışma tektir, maliyet doğrusaldır (11. AYAK her koşumda ölçer).
 *
 * TLD `\p{L}{2,}`dir — SAYI DEĞİL. `127.0.0.1`, `dsn=4.4.1` ve `5.7.1` bu
 * yüzden alan adı sayılmaz; teşhis metninin sürüm/kod alanları korunur.
 */
const TLD_ALAN = String.raw `(?:[${SOZCUK}][${SOZCUK}-]*\.)+\p{L}{2,}`;
/**
 * Adres desenini kurar. İKİ DAL:
 *   1. BİTİŞİK  — `YEREL(@ALAN)+`. Tek etiketli host ve IP literali burada.
 *   2. ARALI    — `YEREL (boşluk) @ (boşluk) TLD_ALAN`. Atıl söküm artığı boşlukları kapsar;
 *      TLD zorunluluğu yanlış pozitifi (`Error @ line 5`) engeller.
 *
 * `@` TEKRARI DA YUTULUR — `@+` (dokuzuncu dalga, 17.09.2026). Atıl maddenin
 * İÇİNE konan YEM `@` sökülünce geriye `yerel@@alan.com` kalıyordu ve eski
 * desen (`@ALAN`) bunu HİÇ eşleştirmiyordu: ikinci `@` bir ALAN başlangıcı
 * değildir, yani en kötü hâlde yem `@` desenin kendisini kilitliyordu. Ölçüldü:
 * kapının n² yem ikizinde beş bileşim bu yüzden ham kalıyordu. Fail-closed yön
 * `(?:@ALAN)+` zincirindekiyle aynıdır: `a@@b.com` yazımında hangi `@`nin
 * gerçek ayırıcı olduğu bilinemez, tamamı maskelenir. Aralı dalda tekrar
 * `(?:ara@)+` biçimindedir (boşlukla bölünmüş yem `@`ler için) ve her yineleme
 * zorunlu `@` ile ÇAPALIDIR — belirsizlik yoktur, maliyet doğrusal kalır.
 *
 * `@` ZİNCİRİ TEK PARÇADIR — `(?:@ALAN)+`, `@ALAN` DEĞİL (yedinci dalga sınıf
 * taraması, 16.09.2026). Kusur ÖLÇÜLDÜ: çözücüler yerel adın İÇİNE bir `@`
 * getirdiğinde (`to=ali%40veli@ornek.com` · `YWxpQHguY28@ornek.com` ·
 * `616c6940782e636f@ornek.com` — yüzde kodu, base64 ve onaltılık gövde)
 * kanonik biçim `L@D1@D2` oluyordu; desen açgözlü biçimde `L@D1`i alıyor,
 * geriye kalan `@D2` yeni bir YEREL bulamadığı için HİÇ eşleşmiyor ve ALAN ADI
 * ekranda HAM kalıyordu (`[eposta]@ornek.com`). Zincirin tamamını yutmak
 * fail-closed yöndür: `a@b@c.com` yazımında hangi parçanın gerçek alıcı olduğu
 * bilinemez, üçü de maskelenir. Tekrarlar zorunlu `@` ile ÇAPALIDIR, yani
 * yinelemeler arası belirsizlik yoktur ve maliyet doğrusal kalır (11. AYAK).
 */
export function adresDeseni(ayar = YAPISAL_VARSAYILAN) {
    const ara = `[ \\t]{0,${Math.max(0, ayar.araEsigi)}}`;
    const araliAlan = ayar.tldZorunlu ? TLD_ALAN : ALAN_BITISIK;
    return new RegExp(`${YEREL}(?:(?:@+${ALAN_BITISIK})+|(?:${ara}@)+${ara}${araliAlan})`, 'gu');
}
/**
 * "Bu dizge adres İÇERİYOR mu?" — GÖMÜLÜ İKİLİ GÖVDE KAPISININ ölçüsü.
 *
 * `email-mask-decoders.ts` base64/onaltılık/base32 gövdesini ancak çözümü
 * GERÇEKTEN adres biçimindeyse yerine koyar. O kapı eskiden kendi mini
 * desenini taşıyordu (`[harf]@[harf]`) ve YAPIYI TANIMIYORDU: `ali @ ornek.com`
 * kodlanmış bir gövdeden çözüldüğünde kapı "adres değil" deyip gövdeyi ham
 * bırakıyordu. İki ayrı adres tanımı zamanla ayrışır; tek tanım burada durur.
 *
 * Desen `g` bayrağı OLMADAN kurulur: `test` çağrısı durum taşımaz.
 */
const ADRES_VAR_MI = new RegExp(adresDeseni().source, 'u');
export function adresVarMi(metin) {
    return ADRES_VAR_MI.test(metin);
}
//# sourceMappingURL=email-mask-desen.js.map